import { makeStyles } from "@material-ui/core";
import styled from "styled-components";

import { theme } from "../../themes/themes";
export const EventTitle = styled.p`
  font-weight: bold;
  color: ${({ theme }) => theme.primary.purple};
  font-family: ${({ theme }) => theme.secondaryFontFamilyFour};
  padding: 0.5em 0.5em 0;
  margin-bottom: 0;
  font-size: 16px;
  @media only screen and (max-width: 480px) {
    margin-left: inherit;
  }
`;

export const SpeakerDescription = styled.p`
  color: ${({ theme }) => theme.primary.purple};
  font-family: ${({ theme }) => theme.secondaryFontFamilyFour};
  padding: 0 0.5em;
  font-size: 12px;
  margin: 0.2em auto;
  @media only screen and (max-width: 480px) {
    margin-left: inherit;
  }
`;

export const EventDateDescription = styled.p`
  color: ${({ theme }) => theme.primary.purple};
  font-family: ${({ theme }) => theme.secondaryFontFamilyFour};
  padding: 0 0.5em;
  margin: 0.2em auto;
  font-size: 12px;
  .freq-text{
    text-transform: capitalize;
  }
  @media only screen and (max-width: 480px) {
    margin-left: inherit;
  }
`;

export const AttendeesLangDescripAndButton = styled.p`
  color: #989898;
  font-family: ${({ theme }) => theme.secondaryFontFamilyFour};
  margin-bottom: 0.5em;
  padding: 0 0.5em;
  margin-left: -2em;
  font-size: 12px;
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

export const ButtonViewDetails = styled.div`
  display: flex;
  justify-content: flex-end;
  justify-self: center;
  align-self: center;
  align-items: center;
  background-color: ${({ theme }) => theme.button.primary};
  color: ${({ theme }) => theme.neutral.white};
  width: 3.4375em;
  height: 1.5625em;
  margin-right: 0.8em;
  &:hover {
    box-shadow: 0px 4px 20px 0px ${({ theme }) => theme.shadows.strong};
    transform: translateY(-1px);
    cursor: pointer;
    background-color: ${({ theme }) => theme.button.primaryHover};
    color: ${({ theme }) => theme.neutral.white};
  }
`;

export const ContentDescriptLang = styled.span`
  display: flex;
  align-items: center;
  margin-left: 0.8rem;
`;

export const ImgUsa = styled.img`
  width: 1.5em;
  margin-left: 1em;
  margin-right: 0.5em;
`;

export const useStyles = makeStyles(() => ({
  imgOtherEvent: {
    width: "100%",
    height: "100%",
  },
  containerEvents: {
    boxShadow: "0px 2px 8px rgba(46, 46, 46, 0.1)",
    borderRadius: "5px",
    width: "fit-content",
    height: "fit-content",
    marginRight: "1.8em",
    marginBottom: "1.8em",
  },
}));

export const ContentImgEvents = styled.div`
  width: 226.27px;
  height: 137px;
  margin: 1.8em 0.5em 0em 0.5em;
`;

export const EventInfo = styled.div``;

export const Attendees = styled.p`
  color: ${({ theme }) => theme.primary.purple};
  font-family: ${({ theme }) => theme.secondaryFontFamilyFour};
  padding: 0 0.5em;
  font-size: 12px;
  margin: 0.2em auto;
  @media only screen and (max-width: 480px) {
    margin-left: inherit;
  }
`;

export const FullEventInfo = styled.div`
  display: flex;
  justify-self: center;
  justify-content: center;
  background-color: #a9a9a9;
  width: 8em;
  height: 1.6em;
  font-weight: bold;
  color: white;
  border-radius: 0 0 99px 99px;
`;

export const ContentFullEventInfo = styled.div`
  display: flex;
  width: 100%;
  justify-content: center;
`;
